type Props = {
  title: string
}

export const SectionDividerLabel = ({ title }: Props) => {
  const getIcon = () => {
    switch (title) {
      case 'IPM':
      case 'Pre-IPM':
        return <img src="/images/section-ipm-icon.svg" alt={title} />
      case 'Draft':
        return <img src="/images/section-draft-icon.svg" alt={title} />
    }
  }

  return (
    <div className="flex-1 flex justify-between gap-4 p-2 bg-surface-iterationMarker-icebox h-10">
      <div className="flex gap-1 items-center">
        <div className="h-5 w-5 flex justify-center items-center">{getIcon()}</div>
        <p className="font-EN-KR-body2-bold text-tb-grey-000">{title}</p>
      </div>
    </div>
  )
}
